import { useQuery } from "@tanstack/react-query"
import { privateApi } from "../../../api/api";
import { PermissionResponseSchema } from "../response/PermissionResponse";
import { ErrorResponse } from "../response/ErrorResponse";

interface useGetPermissionByIDProps {
    id: number | undefined;
}

export const useGetPermissionByID = ({ id }: useGetPermissionByIDProps) => {
    return useQuery({
        queryKey: ['permission', id],
        queryFn: async () => {
            try {
                const response = await privateApi.get(`/v3/permission/${id}`);

                const validationResult = PermissionResponseSchema.safeParse(response.data);

                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid permission data format");
                }

                return validationResult.data;
            } catch (error) {
                const validationResult = ErrorResponse.safeParse((error as any).response?.data);

                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid error response format");
                } else {
                    console.error('Failed to fetch permission', error);
                    throw error;
                }

            }
        },
        enabled: !!id,
    });
}